
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 40 40","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#D8D8D8","fill-rule":"nonzero","cx":"20","cy":"20","r":"20"}}),_c('g',{attrs:{"transform":"translate(9 10)","fill":"#9B9B9B"}},[_c('path',{attrs:{"d":"M9.075 8.862c.661 1.664.887 3.272.679 4.825-2.17.9-3.795 1.35-4.876 1.35-1.08 0-2.707-.45-4.878-1.35.002-2.259.194-3.867.574-4.825.571-1.436 7.51-2.495 8.501 0z"}}),_c('ellipse',{attrs:{"cx":"4.657","cy":"3.989","rx":"3.657","ry":"3.86"}})]),_c('g',{attrs:{"transform":"translate(22 10)","fill":"#9B9B9B"}},[_c('path',{attrs:{"d":"M9.075 8.862c.661 1.664.887 3.272.679 4.825-2.17.9-3.795 1.35-4.876 1.35-1.08 0-2.707-.45-4.878-1.35.002-2.259.194-3.867.574-4.825.571-1.436 7.51-2.495 8.501 0z"}}),_c('ellipse',{attrs:{"cx":"4.535","cy":"3.989","rx":"3.779","ry":"3.989"}})]),_c('path',{attrs:{"d":"M25.74 22.575c.828 1.587 1.145 3.603.953 6.048-3.046 1.128-5.327 1.692-6.845 1.692-1.517 0-3.8-.564-6.848-1.692-.258-2.445.01-4.46.807-6.048 1.193-2.38 10.693-2.38 11.934 0z","stroke":"#CDCDCD","fill":"#6F6F6F"}}),_c('ellipse',{attrs:{"stroke":"#CDCDCD","fill":"#6F6F6F","cx":"20","cy":"17.712","rx":"5","ry":"4.712"}})])])
          )
        }
      }
    